module.exports = __webpack_public_path__ + "img/Roboto-Regular.d685350.svg";